import { render } from "./Footer.vue?vue&type=template&id=bc28032e&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=bc28032e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3710787608/src/iristravel-hotel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc28032e"]])

export default __exports__